import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import React, { useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ".././styles.css";

export default function ProductDisplayTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();

  const [colDefs] = useState([
    // { field: "", filter: false, headerName: "Select" },

    {
      field: "product",
      headerName: "Product",
      hide: false,
      flex: 2,
    },
    {
      field: "variant",
      headerName: "Variant",
      hide: false,
      flex: 2,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      hide: false,
      flex: 2,
    },
    {
      field: "price",
      headerName: "Price",
      hide: false,
      flex: 2,
    },
    {
      field: "coupon",
      headerName: "Coupon",
      hide: false,
      flex: 2,
    },
    {
      field: "discount",
      headerName: "Discount",
      hide: false,
      flex: 2,
    },
    {
      field: "shippingCharges",
      headerName: "Shipping Charges",
      hide: false,
      flex: 2,
    },
  ]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    // floatingFilter: true,
    // flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  return (
    <div>
      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        }`} // applying the grid theme
        style={{ height: 500 }} // the grid will fill the size of the parent container
      >
        <Card className="shadow-none h-100 rounded-0">
          {/* <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
              Contacts & Physicians
            </h5>
          </Card.Header> */}

          <Card.Body className="p-0">
            {/* <button onClick={() => onExportClick()}>abc</button> */}

            <AgGridReact
              rowData={[]}
              ref={columnApiRef}
              //   onGridReady={onGridReady}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              rowStyle={{ cursor: "pointer" }}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
              // pagination={true}
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
